module.exports = __webpack_public_path__ + "static/media/confeitaria-marina-site.624ecf8c.jpg";